/** F-064: the schedule form starts from the frequency and responsible team already held on the requirement; typing overrides them. */
export function scheduleFieldValue(entered:string,held:string|number|null|undefined){
  return entered!==''?entered:held===null||held===undefined?'':String(held);
}
